import {
  DataView,
  Pagination,
  Search,
  Table,
  TBody,
  TBodyCell,
  TBodyRow,
  THead,
  THeadCell,
  useDataViewState,
  useTableState,
  Text,
} from '@vtex/admin-ui'
import { Item } from 'typings'
import { columns } from './constants'
import { styles } from './styles'
import { useSearch } from './hooks/useSearch'
import { usePagination } from './hooks/usePagination'
import { FormattedMessage } from 'react-intl'
import { messages } from './messages'

export const DEBOUNCE_TIMEOUT: number = 500

type Props = {
  sellers: Item[]
}

export function OptInTable(props: Props) {
  const { sellers } = props

  const dataState = useDataViewState()

  const { getHeadCell, getTable } = useTableState({
    status: dataState.status,
    columns,
    items: sellers,
  })

  const { filteredItems, getInputProps } = useSearch({
    dataState,
    items: sellers,
  })

  const { pageItems, paginationState } = usePagination({ items: filteredItems })

  const resolveCell = (cellData) => {
    const NAME_COLUMN = 'name'
    if (cellData.column.id !== NAME_COLUMN)
      return cellData.item[cellData.column.id]

    if (!cellData.item[NAME_COLUMN])
      return (
        <Text tone="secondary">
          <FormattedMessage {...messages.drawer.emptyName} />
        </Text>
      )

    return cellData.item[NAME_COLUMN]
  }

  return (
    <div className={styles.tableContainer}>
      <div className={styles.topContainer}>
        <Search {...getInputProps()} />
        <Pagination state={paginationState} className={styles.pagination} />
      </div>
      <DataView state={dataState}>
        <Table {...getTable()} className={styles.fullWidth}>
          <THead>
            {columns.map((column, columnIndex) => (
              <THeadCell {...getHeadCell(column)} key={columnIndex} />
            ))}
          </THead>
          <TBody>
            {pageItems.map((item) => {
              return (
                <TBodyRow key={item.id}>
                  {columns.map((column, columnIndex) => {
                    return (
                      <TBodyCell
                        item={item}
                        column={column}
                        resolveCell={resolveCell}
                        key={columnIndex}
                        className={styles.cell}
                      />
                    )
                  })}
                </TBodyRow>
              )
            })}
          </TBody>
        </Table>
      </DataView>
    </div>
  )
}
